import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { AppWrapped } from './App';
import { configureRouter } from './router';
import { configureStore } from './store';
import './index.css';
import { ConfigProvider } from 'antd';
import { ImportedAppModule } from './appModule';
import { appTheme } from './consts/theme';

const createRootNode = () => {
  const node = document.createElement('div');
  node.id = 'stud-reg-form';
  document.body.appendChild(node);
  return node;
};

const setupApp = async () => {
  const dedicatedNode = document.getElementById('stud-reg-form');

  const node = dedicatedNode ?? createRootNode();

  const root = createRoot(node);

  const modules: ImportedAppModule[] = [import('./form')];

  console.debug('configuring router and store');
  const router = await configureRouter({ modules });
  const store = await configureStore({ router, modules });

  router.start();

  root.render(
    <StrictMode>
      <Provider store={store}>
        <ConfigProvider theme={appTheme}>
          <AppWrapped />
        </ConfigProvider>
      </Provider>
    </StrictMode>,
  );
};

setupApp();
